import React from 'react';
import  { useState , useEffect } from 'react';

const Card = ({ element }) => {
	const [bg, setBg] = useState('');

	useEffect(() => {
		if (Object.values(element.type)[0] === "External partner") {
			setBg('external-partner-color');
		} else if (Object.values(element.type)[0] === "Research center") {
			setBg('research-center-color');
		} else if (Object.values(element.type)[0] === "Corporate partner") {
			setBg('corporate-partner-color');
		}

		}, [element]);


	return (
		// <a className="tile" >
			<article className='tile'>
				<div className="tile__header">
					<figure className={`tile__img-wrapper ${bg}`}>
						<img className="tile__img" src={element.poster_desktop} alt={element.title} />

						{element.data && (
							<div className="tile__data-container">
								<span className='tile__data-text'>
									DNA <br></br>
									profiles
								</span>
								<span className='tile__data-number'>
								{ element.data}

								</span>

							</div>
						)
						}
					</figure>
				</div>

				<div className="tile__content-wrapper">
					<div className="tile__details">
						<h3 className="tile__title">{element.title}</h3>
						<h4 className="tile__subheader">{element.type ? Object.values(element.type)[0] : ''}</h4>
					</div>
						<div className="tile__location">
							{/* TODO: add location icon here */}
							<div className="tile__location-text">{element.location}</div>
						</div>
						{element.researcher && (
							<div className="tile__researcher">
								<div className="tile__researcher-text">
									<span>Main researcher</span> <br></br>
									<span>{element.researcher}</span>
								</div>
							</div>
						)}
					<a className="tile__cta cta" href={element.permalink}>
						Read more
						<svg className="btn__icon" xmlns="http://www.w3.org/2000/svg" width="25" height="22" viewBox="0 0 25 22" fill="none">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M12.9843 0.707107C13.3748 0.316582 14.008 0.316582 14.3985 0.707107L23.5906 9.89918L22.8838 10.6066L23.5909 11.3137L14.3985 20.5061C14.008 20.8966 13.3748 20.8966 12.9843 20.5061C12.5938 20.1156 12.5938 19.4824 12.9843 19.0919L21.4696 10.6066L12.9843 2.12132C12.5938 1.7308 12.5938 1.09763 12.9843 0.707107ZM22.8838 10.6066L23.5909 11.3137C23.9814 10.9232 23.9811 10.2897 23.5906 9.89918L22.8838 10.6066Z"
								fill="white"
							/>
							<path
								class="arrow-base"
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M0 10.4141C0 9.86178 0.447715 9.41406 1 9.41406H22.5C23.0523 9.41406 23.5 9.86178 23.5 10.4141C23.5 10.9663 23.0523 11.4141 22.5 11.4141H1C0.447715 11.4141 0 10.9663 0 10.4141Z"
								fill="white"
							/>
						</svg>
						{/* TODO: add icon here */}
					</a>
				</div>
			</article>
		// </a>
	);
};

export default Card;
